// Importing the required type for center data
import { ICenterPayloadResponse, ICenterPayload, ICenters, ICentersApiResponse } from "../../../features/center/types";
import { ICentersListRepsonse } from "../../../Types/Center";

// Importing the base ApiService class to inherit HTTP request functionality
import ApiService from "../../ApiService";

enum CenterServiceEndpoints {
  CENTER_LIST = "/centers-list",
  CENTER_LISTS = "/centers",
}
export interface ICenterListParams {
  page?: number;
  size?: number;
  search?: string;
  status?: string;
  parent_id?: number;
}

class CenterListService extends ApiService {
  // Method to fetch the list of all centers from the API
  async getAllCenters(): Promise<ICentersListRepsonse> {
    return this.get<ICentersListRepsonse>(CenterServiceEndpoints.CENTER_LIST);
  }

  async getAllCenterList(params?: ICenterListParams): Promise<ICentersApiResponse> {
    const queryParams = new URLSearchParams();

    if (params?.page) queryParams.append("page", String(params.page));
    if (params?.size) queryParams.append("size", String(params.size));
    if (params?.search) queryParams.append("search", params.search);
    if (params?.status) queryParams.append("status", params.status);
    if (params?.parent_id !== undefined && params?.parent_id !== null) {
      queryParams.append("parent_id", String(params.parent_id));
    }

    const queryString = queryParams.toString();

    const url = `${CenterServiceEndpoints.CENTER_LISTS}${queryString ? `?${queryString}` : ""
      }`;

    return this.get<ICentersApiResponse>(url);
  }

  async saveCenter(payload: Partial<ICenterPayload>): Promise<ICenterPayloadResponse> {
    return this.post<ICenterPayloadResponse>(`${CenterServiceEndpoints.CENTER_LISTS}`, payload);
  }

  async getCenterById(id: number): Promise<ICentersApiResponse> {
    return this.get<ICentersApiResponse>(`${CenterServiceEndpoints.CENTER_LISTS}/${id}`);
  }

  async updateCenter(id: number, payload: Partial<ICenterPayload>): Promise<ICenterPayloadResponse> {
    return this.post<ICenterPayloadResponse>(`${CenterServiceEndpoints.CENTER_LISTS}/${id}`, payload);
  }

}

// Creating an instance of the CenterList class and exporting it for use in other parts of the application
export const centerListService = new CenterListService(); // Exporting the instance of CenterList to access its methods elsewhere
